
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="maxImages > 1">Media Library - {{countSelected}} of {{maxImages}} Selected</ion-title>
    <ion-title *ngIf="maxImages == 1">Media Library</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div id="images">
    <app-add-image (imageChanged)="imageAdded($event)" [includeLibraryButton]="false"
      height="175px" width="175px"></app-add-image>

    <div class="image" *ngFor="let img of images; let idx = index;">
      <img [src]="img.path" [class.selected]="selectedIdxs.includes(idx)" (click)="select(idx)"/>
      <div class="remove" (click)="remove(idx)">
        <ion-icon name="close-circle-outline"></ion-icon>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="apply()" color="primary">
        Use Selected Images
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>